import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GetIpstackService {
 constructor(private httpClient: HttpClient) {
  }
  getIPstackService(): Observable<any> {
   /*  const IPstackKey = '66aade7c17509796149fe12f76495277';
    const prodIPstackKey = '35d3e627c464cf7ef5996734521adea5';
    const dummyIPstackKey = '66aade7c17509796149fe12f76495277'; */
    return this.httpClient.get('https://api.ipstack.com/check?access_key=' + environment.IPstackKey);
  }
}
